import React, { Component } from 'react'
import { BrowserRouter as Router, NavLink as Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ActionCreators } from '../../redux/actions/index'
import SideMenu from '../SideMenu'

class HeaderNav extends Component<{}> {
  constructor(props){
    super(props)
    this.state = {
      open_menu: false
    }
  }
  _handleKeyDown = (event) => {
    switch( event.keyCode ) {
      case 27:
        this.setState({open_menu: false})
          break;
      default: 
          break;
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this._handleKeyDown);
  }
  render() {
    return (<>
      <header id="admin-header" style={{background: 'rgb(0,183,255)', background: 'linear-gradient(128deg, rgba(0,183,255,1) 0%, rgba(160,0,255,1) 100%)'}}>
        {
          this.props.redux.user && <a href="https://discord.com/channels/707614343188971530/903695463109242891"><img className="avatar" src={this.props.redux.user.pfp || require('../../images/social/discord-animated.gif').default} alt={this.props.redux.user.discord.username} style={{width: 45, height: 45}}/></a>
        }
        <div id="nav-menu">
          { this.props.redux.user.super_admin && <>
          <Link to="/"><li>Dashboard</li></Link>
          <Link to="/releases"><li>Releases</li></Link>
          <Link to="/egg"><li>Egg</li></Link>
          </>}
          <Link to="/rss"><li>RSS</li></Link>
          { this.props.redux.user.super_admin && <>
          <Link to="/gallery"><li>Gallery</li></Link>
          <Link to="/bio"><li>Bio</li></Link>
          <Link to="/settings"><li>Settings</li></Link>
          </>}
        </div>
       </header>

       <div id="mobile-menu">
          <div onClick={()=>{this.setState({open_menu: !this.state.open_menu})}} className="mobile-toggle"><i className="fas fa-bars"></i></div>
          <SideMenu open={this.state.open_menu}>
            <div className="mobile-toggle inside" onClick={()=>{this.setState({open_menu: !this.state.open_menu})}}>
              <i className="fas fa-times"></i>   
            </div>
            <div className="menu-items">
              { this.props.redux.user.super_admin && <>
                  <Link to="/"><li onClick={()=>{this.setState({open_menu: false})}}>Dashboard</li></Link>
                  <Link to="/releases"><li onClick={()=>{this.setState({open_menu: false})}}>Releases</li></Link>
                  <Link to="/egg"><li onClick={()=>{this.setState({open_menu: false})}}>Egg</li></Link>
              </>}
                  <Link to="/rss"><li onClick={()=>{this.setState({open_menu: false})}}>RSS</li></Link>
              { this.props.redux.user.super_admin && <>
                  <Link to="/gallery"><li onClick={()=>{this.setState({open_menu: false})}}>Gallery</li></Link>
                  <Link to="/bio"><li onClick={()=>{this.setState({open_menu: false})}}>Bio</li></Link>
                  <Link to="/settings"><li onClick={()=>{this.setState({open_menu: false})}}>Settings</li></Link>
              </>}
            </div>
            <p>Menu things</p>
          </SideMenu>
        </div>
    </>)
  }
}

function mapStateToProps(redux) {
  return {
    redux
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(ActionCreators, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNav)